import { computed, inject } from '@angular/core';

import { AuthQuery } from '@shared/store/auth/auth.query';
import { MainQuery } from '@shared/store/main/main.query';

export const injectColumnChooserConfigName = (configName: string) => {
  const mainQuery = inject(MainQuery);
  const authQuery = inject(AuthQuery);

  return computed(() => {
    const { trialKey } = mainQuery.mainState();
    const { sub } = authQuery.user();

    return `${configName}-${trialKey}-${sub}`;
  });
};
